import React from "react";
import StepIndicator from "../subComponent/step-indicator/StepIndicator";
import { SuccessAlertComponent } from "../odsCalloutBox/SuccessAlertComponent";
import {
  FormSectionElements,
  ProgramContainer,
} from "../../entities/formTemplateDataType";
import FeedbackComponent from "../subComponent/FeedbackComponent";
import { FeedbackStatus } from "../../entities/Constants";
import TrackPageView from "../../utilities/TrackPageView";
import { normalizeUrl } from "../../utilities/URLUtils";
import { getEnvVar } from "../../config/RuntimeConfig";

interface Props {
  programContainer: ProgramContainer;
  isEng: boolean;
  transactionId: string;
  Visible: boolean;
  callback: (p: any) => void;
  uploadReceiptSuccess: boolean;
  showDownloadSummary: boolean;
  applicationType: string;
  renewType?: string; 
}

export class APPOrderConfirmationComponent extends React.Component<Props> {
  field: FormSectionElements;
  constructor(props: Props) {
    super(props);

    this.field = new FormSectionElements();
    sessionStorage.removeItem("AppSummaryFired");
  }

  downloadReceipt(transId: string) {
    const url = getEnvVar('DOWNLOAD_RECEIPT_URL').replace(
      "{transactionID}",
      transId
    );
    fetch(url)
      .then((resp) => resp.arrayBuffer())
      .then((buf) => {
        const blob = new Blob([buf], { type: "application/pdf" });
        const anchor = document.createElement("a");

        anchor.href = window.URL.createObjectURL(blob);
        anchor.download = `Receipt-${transId}`;
        anchor.hidden = true;

        document.body.append(anchor);
        anchor.click();
        anchor.remove();

        // in case the Blob uses a lot of memory
        window.addEventListener(
          "focus",
          () => {
            URL.revokeObjectURL(anchor.href);
          },
          {
            once: true,
          }
        );
      });
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<{}>, snapshot?: any): void {
      if (!this.props.Visible) return;
    const title = "your-renewal-application-has-been-submitted"
    const isEng = window.location.href.indexOf("/fr/") == -1;

    let preUrl = window.location.origin + "/on-form/app/review-your-information";
    if (!prevProps.isEng) {
      preUrl = window.location.origin + "/on-form/fr/app/review-your-information";
    }

    sessionStorage.setItem("previousUrl", preUrl);

    let urlString = window.location.origin + "/on-form/app/" + title;

    if (!isEng) {
      urlString = window.location.origin + "/on-form/fr/app/" + title;
    }
    window.history.pushState({}, "", normalizeUrl(urlString));

    if (this.props.Visible && sessionStorage.getItem("languageChange") != "true" && sessionStorage.getItem("AppSummaryFired") != "true") {
      TrackPageView(this.props.programContainer);
      sessionStorage.setItem("AppSummaryFired", "true");
      sessionStorage.removeItem("languageChange")
    }
  }
componentWillUnmount(): void {
    sessionStorage.removeItem("AppSummaryFired")
    sessionStorage.removeItem("languageChange")
}
  handleDownloadApplicationSummary(): void {
    try {
      const transId = this.props.transactionId;
      const url = getEnvVar('DOWNLOAD_SUMMARY_URL').replace(
        "{transactionID}",
        transId
      );
      fetch(url)
        .then((resp) => resp.arrayBuffer())
        .then((buf) => {
          const blob = new Blob([buf], { type: "application/pdf" });
          const anchor = document.createElement("a");
          anchor.href = window.URL.createObjectURL(blob);
          anchor.download = `${transId}-summary`;
          anchor.hidden = true;
          document.body.append(anchor);
          anchor.click();
          anchor.remove();
          window.addEventListener(
            "focus",
            () => {
              URL.revokeObjectURL(anchor.href);
            },
            {
              once: true,
            }
          );
        });
    } catch (ex) {
      console.log(ex);
    }
  }

  render() {
    if (!this.props.Visible) return null;
  
    const isEng =window.location.href.indexOf("/fr/")==-1;
    const profile = this.props.programContainer.Profile;
    const isTravellerOrMotorcycle = ["Traveller", "Motorcycle_decal"].includes(this.props.renewType);
    let backToLabel;
    let backToUrl;
    let body;
    let feedbackUrl;
    if (profile && profile.email) {
      backToLabel = isEng ? "Back to home" : "Retour à l'accueil";
      backToUrl =
        getEnvVar('PUBLIC_CXP_WEB_BASE_PATH') +
        "/auth/signin?redirectUri=" +
        (isEng ? "" : "/fr") +
        "/dashboard";
      body = isEng
        ? "A confirmation receipt will be sent to your inbox."
        : "Un message de confirmation sera envoyé à votre boîte de réception.";
    } else {
      backToLabel = isEng
        ? "Back to Ontario.ca"
        : "Revenir à Ontario.ca";
      backToUrl = isEng
        ? "https://www.ontario.ca/page/government-ontario"
        : "https://www.ontario.ca/fr/page/gouvernement-de-lontario";
    }
    feedbackUrl = isEng
      ? getEnvVar('FEEDBACK_URL_NO_CXP_USER')
      : getEnvVar('FEEDBACK_URL_NO_CXP_USER_F');

    if (isTravellerOrMotorcycle) {
      return (
        <div>
          {/* Step Indicator */}
          <div>
            <StepIndicator
              withbackbtn={true}
              sectionSequence={-1}
              title={backToLabel}
              programContainer={this.props.programContainer}
              isEng={isEng}
              callback={(currentStep) => {
                this.setState({ stepperIndex: currentStep });
              }}
            />
          </div>

          {/* Success Alert */}
          <SuccessAlertComponent
            bodyMsg={
              isEng
                ? "Thank you! We have received your application and will review your request."
                : "Nous vous remercions! Nous avons reçu votre demande et nous l'examinerons."
            }
            title={isEng ? "Application submitted" : "La demande a été soumise"}
            isEng={isEng}
            Visible={true}
            field={this.field}
          />

          {/* Simplified Content */}
          <div>
            <h1>
              {isEng
                ? "Next steps after you have applied"
                : "Prochaines étapes après avoir présenté votre demande"}
            </h1>
            <p>
              {isEng ? "Order ID: " : "Numéro de commande: "}
              {this.props.transactionId}
            </p>
            
            <ul>
              <li>
                {isEng
                  ? "keep your email confirmation for your records"
                  : "conservez votre courriel de confirmation pour vos dossiers"}
              </li>
              <li>
                {isEng
                  ? "if the application is successful, it may take up to 3 weeks to receive your permit in the mail"
                  : "si la demande est approuvée, cela peut prendre jusqu'à 3 semaines pour recevoir votre permis par la poste"}
              </li>
              <li>
                {isEng
                  ? "the Accessible Parking Permit Office will contact you if there are issues processing your request"
                  : "le Bureau des permis de stationnement accessible communiquera avec vous s'il y a des problèmes dans le traitement de votre demande"}
              </li>
              <li>
                {isEng
                  ? "if you do not receive your new permit or address update letter in the mail within this time, please contact the ServiceOntario Centre. Call toll-free at 1-800-387-3445 (TTY 1-800-268-7095)"
                  : "si vous ne recevez pas votre nouveau permis ou votre lettre de mise à jour d'adresse par la poste dans ce délai, veuillez communiquer avec le Centre ServiceOntario. Composez sans frais le 1 800 387-3445 (ATS : 1 800 268-7095)"}
              </li>
            </ul>
          </div>

          {/* Feedback */}
          <div>
            <FeedbackComponent
              programContainer={this.props.programContainer}
              isEng={isEng}
              transactionId={this.props.transactionId}
              status={FeedbackStatus.Success}
              applicationType={this.props.applicationType}
              isHyperlink
            />
          </div>
        </div>
      );
    }
    return (
      <div>
        {/* Step Indicator */}
        <div>
          <StepIndicator
            withbackbtn={true}
            sectionSequence={-1}
            title={backToLabel}
            programContainer={this.props.programContainer}
            isEng={isEng}
            callback={(currentStep) => {
              this.setState({ stepperIndex: currentStep });
            }}
          />
        </div>

        {/* Success Alert */}
        <SuccessAlertComponent
          bodyMsg={
            isEng
              ? "Thank you! We have received your application and will review your request."
              : "Nous vous remercions! Nous avons reçu votre demande et nous l’examinerons."
          }
          title={isEng ? "Application submitted" : "La demande a été soumise"}
          isEng={isEng}
          Visible={true}
          field={this.field}
        />

        {/* Main Confirmation Heading */}
        <div>
          <h1>
            {isEng
              ? "Your application has been submitted"
              : "Votre demande a été soumise. "}
          </h1>
          <p style={{ fontSize: "22px" }}>
            {isEng ? "Order ID: " : "Numéro de commande: "}
            {this.props.transactionId}
          </p>
          <p style={{ fontSize: "22px" }}>
            {isEng
              ? "You can download the application summary to your device. The application summary has also been sent to your account inbox."
              : "Vous pouvez télécharger le résumé de la demande sur votre appareil. Vous pouvez aussi télécharger le résumé de la demande en cliquant sur le lien envoyé à votre adresse courriel. Ce lien expirera dans cinq jours."}
          </p>
        </div>

        {/* Download Button */}
        {this.props.showDownloadSummary && (
          <div>
            <button
              className="ontario-button--primary button--22em ontario-button"
              id={`button_downloadApplicationSummary_id`}
              title={
                isEng
                  ? "Download application summary"
                  : "Télécharger le résumé de la demande"
              }
              onClick={(e) => this.handleDownloadApplicationSummary()}
            >
              {isEng
                ? "Download application summary"
                : "Télécharger le résumé de la demande"}
            </button>
          </div>
        )}

        {/* Important Note */}
        <div>
          <p>
            <svg
              className="ontario-icon"
              aria-hidden="true"
              focusable="false"
              viewBox="0 0 24 24"
              preserveAspectRatio="xMidYMid meet"
            >
              <use href="#ontario-icon-alert-information"></use>
            </svg>
            {isEng
              ? "IMPORTANT: Check your downloaded files for your application summary before closing this screen."
              : "IMPORTANT : Veuillez vérifier que le résumé de la demande est dans vos fichiers téléchargés avant de fermer cette page."}
          </p>
        </div>

        {/* Interim Permit Section */}
        <div>
          <h2>{isEng ? "Interim Permit" : "Permis temporaire "}</h2>
          <p>
            {isEng
              ? "If you are applying for the first time, or your existing permit is expired, lost or reported stolen you may be eligible for an interim accessible parking permit from your "
              : "Si vous faites une demande pour la première fois, ou si votre permis actuel est expiré, perdu ou déclaré volé, vous pourriez être admissible à un permis temporaire de stationnement accessible que vous pouvez vous procurer à "}
            <a
              href={`https://www.ontario.ca${isEng?"":"/fr"}/locations/serviceontario`}
              rel="noopener noreferrer"
              target="_blank"
            >
              {isEng
                ? "local ServiceOntario centre"
                : "votre centre ServiceOntario local"}
            </a>
            .
          </p>
          <p>
            {isEng
              ? "Present your downloaded application summary (digital or print copy), and the necessary "
              : "Veuillez présenter une version numérique ou imprimée du résumé de demande que vous avez téléchargé et les "}
            <a
              href={
                isEng
                  ? "https://www.ontario.ca/page/renew-replace-or-change-accessible-parking-permit#section-8"
                  : "https://www.ontario.ca/fr/page/renouvellement-remplacement-ou-modification-de-renseignements-sur-un-permis-de-stationnement#section-8"
              }
              rel="noopener noreferrer"
              target="_blank"
            >
              {isEng ? "identity documents" : "pièces d’identités"}
            </a>{" "}
            {isEng
              ? " to a ServiceOntario centre."
              : " requises à un centre ServiceOntario"}
          </p>
          <p>
            {isEng
              ? `If you are unable to attend ServiceOntario in person and an authorized representative is acting on your behalf, copies of your identity documents and a letter of authorization are required to obtain your interim permit. The authorized representative must also provide their identity documents.`
              : `Si vous ne pouvez pas vous présenter en personne à un centre ServiceOntario et qu’une représentante autorisée ou un représentant autorisé le fait à votre place, des copies de vos pièces d’identité et une lettre d’autorisation seront requises pour obtenir votre permis temporaire. La représentante autorisée ou le représentant autorisé devra aussi présenter ses propres pièces d’identité.`}
          </p>
        </div>

        {/* Next Steps Section */}
        <div>
          <h2>
            {isEng
              ? "Next steps after you have applied"
              : "Prochaines étapes après avoir présenté votre demande"}
          </h2>
          <ul>
            <li>
              {isEng
                ? "Keep your email confirmation for your records."
                : "	Conservez votre courriel de confirmation pour vos dossiers."}
            </li>
            <li>
              {isEng
                ? "The Accessible Parking Permit Office will contact you if there are issues processing your request."
                : "Le Bureau des permis de stationnement accessible communiquera avec vous s’il y a des problèmes dans le traitement de votre demande."}
            </li>
            <li>
              {isEng
                ? "If you do not receive your new permit or address update letter in the mail within 3 weeks, please contact the ServiceOntario Centre. Call toll-free at 1-800-387-3445 (TTY 1-800-268-7095)."
                : "Si vous ne recevez pas votre nouveau permis ou votre nouvelle lettre confirmant la mise à jour de votre adresse postale dans les trois semaines, veuillez communiquer avec le Centre ServiceOntario. Composez sans frais le 1 800 387-3445 (ATS : 1 800 268-7095)."}
            </li>
          </ul>
        </div>

        {/* Feedback */}
        <div>
          <FeedbackComponent
            programContainer={this.props.programContainer}
            isEng={isEng}
            transactionId={this.props.transactionId}
            status={FeedbackStatus.Success}
            applicationType={this.props.applicationType}
            isHyperlink
          />
        </div>
      </div>
    );
  }
}
